export default "/images/vendor/flag-icon-css/flags/4x3/sl.svg?4fd17d63688a1b300bcafac703d5dd7c";